<!-- Vertical Menu -->
@if (layout === 'vertical') {
  @for (item of menu; track item) {
    <!-- section -->
    @if (item.type === 'section') {
      <li xbaht-core-menu-vertical-section [item]="item" class="navigation-header"></li>
    }
    <!-- sub-menu item/collapsible of sections  -->
    @if (item.type === 'section') {
      @for (item of item.children; track item) {
        <!-- item | if openInNewTab set routerLink & routerLinkActive blank -->
        @if (item.type === 'item') {
          <li xbaht-core-menu-vertical-item [item]="item"
            [ngClass]="{ disabled: item.disabled === true }" [routerLinkActive]="!item.openInNewTab ? 'active' : ''"
            [routerLinkActiveOptions]="{ exact: item.exactMatch || false }">
            <span [routerLink]="item.openInNewTab ? [] : [item.url]" class="d-none"></span>
          </li>
        }
        <!-- collapsible -->
        @if (item.type === 'collapsible') {
          <li xbaht-core-menu-vertical-collapsible [item]="item"
          class="nav-item has-sub"></li>
        }
      }
    }
    <!-- item -->
    @if (item.type === 'item') {
      <li xbaht-core-menu-vertical-item [item]="item"
        [ngClass]="{ disabled: item.disabled === true }" [routerLinkActive]="!item.openInNewTab ? 'active' : ''"
        [routerLinkActiveOptions]="{ exact: item.exactMatch || false }">
        <span [routerLink]="item.openInNewTab ? [] : [item.url]" class="d-none"></span>
      </li>
    }
    <!-- collapsible -->
    @if (item.type === 'collapsible') {
      <li xbaht-core-menu-vertical-collapsible [item]="item" class="nav-item has-sub">
      </li>
    }
  }
}
<!--/ Vertical Menu -->

<!-- Horizontal Menu -->
@if (layout === 'horizontal') {
  @for (item of menu; track item) {
    <!-- section -->
    @if (item.type === 'section') {
      <li xbaht-core-menu-horizontal-collapsible [item]="item" class="dropdown nav-item">
      </li>
    }
    <!-- item | if openInNewTab set routerLink & routerLinkActive blank -->
    @if (item.type === 'item') {
      <li xbaht-core-menu-horizontal-item [item]="item"
        [ngClass]="{ disabled: item.disabled === true }" [routerLinkActive]="!item.openInNewTab ? 'active' : ''"
        [routerLinkActiveOptions]="{ exact: item.exactMatch || false }">
        <span [routerLink]="item.openInNewTab ? [] : [item.url]" class="d-none"></span>
      </li>
    }
    <!-- collapsible -->
    @if (item.type === 'collapsible') {
      <li xbaht-core-menu-horizontal-collapsible [item]="item"
      class="dropdown dropdown-submenu"></li>
    }
  }
}
<!--/ Horizontal Menu -->